import schema from './schema';
import { buildASTSchema } from 'graphql/utilities';
import { DocumentNode } from 'graphql';

// eslint-disable-next-line @trello/no-module-logic
export const astSchema = buildASTSchema(schema as DocumentNode, {
  assumeValidSDL: true,
});
